import { render, staticRenderFns } from "./project-details.vue?vue&type=template&id=3a899ab1&scoped=true"
import script from "./project-details.vue?vue&type=script&lang=js"
export * from "./project-details.vue?vue&type=script&lang=js"
import style0 from "./project-details.vue?vue&type=style&index=0&id=3a899ab1&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a899ab1",
  null
  
)

export default component.exports